import { Link, useLocation } from 'react-router-dom';

const tabs = [
  { label: 'Courses', path: '/content/courses' },
  { label: 'Certifications', path: '/content/certifications' },
  { label: 'Course Groups', path: '/content/course-groups' },
  { label: 'Certificates', path: '/content/certificates' },
  { label: 'Badges', path: '/content/badges' },
  { label: 'Additional Content', path: '/content/additional-content' },
];

export function ContentTabNav() {
  const location = useLocation();

  return (
    <div className="border-b border-gray-200 overflow-x-auto">
      <nav className="flex gap-0 min-w-max">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                isActive
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
